import { render, staticRenderFns } from "./HeartHome.vue?vue&type=template&id=137cdc92"
import script from "./HeartHome.vue?vue&type=script&lang=js"
export * from "./HeartHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports